import React, { useEffect, useState } from 'react';
import ImageUploader from 'react-images-upload';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useApi } from '../Store/ApiContext';
import { customAlphabet } from 'nanoid';
import { Upload } from 'lucide-react';
import Spinner from '../Spinner/Spinner';
import { t } from 'i18next';

const UploadRequestImages = ({ data, setData }) => {
  const { getSlug } = useApi();
  // Add state for oldest images
  const [oldestImages, setOldestImages] = useState([]);
  const [uploadedMediaUrls, setUploadedMediaUrls] = useState([]);
  const [loadingUploadImage, setLoadingUploadImage] = useState(false);

  const handleImageUpload = async (images) => {
    setLoadingUploadImage(true);
    const files = (images.target.files);
    const slug = getSlug();
    const storage = getStorage();
    const storageRef = ref(storage, `IDs/${slug}`);
    const uploadedMediaUrl = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].size <= 5242880) {
        const image = files[i];
        const nanoid = customAlphabet('1234567890abcdefghtklmnoqzx', 16);
        const imageName = nanoid();
        const imageRef = ref(storageRef, imageName);
        await uploadBytes(imageRef, image);
        const downloadURL = await getDownloadURL(imageRef);
        // Store the downloadURL in your database
        console.log('Download URL:', downloadURL.split('?')[0] + "?alt=media");

        uploadedMediaUrl.push(downloadURL.split('?')[0] + "?alt=media")
      }
      setUploadedMediaUrls([...uploadedMediaUrls, ...uploadedMediaUrl]);
    }
    setLoadingUploadImage(false);
  };

  async function handleImageRemoveStorage(image) {
    // Check if image is in oldestImages before allowing deletion
    if (oldestImages.includes(image)) {
      return; // Don't allow deletion of oldest images
    }

    const imageName = image.split('%2F').reverse()[0].split("?")[0];
    const storage = getStorage();
    const slug = getSlug();
    const desertRef = ref(storage, `IDs/${slug}/${imageName}`);

    try {
      await deleteObject(desertRef);
    } catch (error) {
      console.log(error);
    }

    const myUrls = [...data.idsImg];
    for (let i = 0; i < myUrls.length; i++) {
      if (myUrls[i].split('%2F').reverse()[0].split("?")[0] === imageName) {
        myUrls.splice(i, 1);
      }
    }
    setUploadedMediaUrls(myUrls);
  }

  useEffect(() => {
    // Set oldest images when component mounts
    if (data.idsImg?.length) {
      setOldestImages(data.idsImg); // Save original images
      setUploadedMediaUrls(data.idsImg);
    }
  }, [])

  useEffect(() => {
    let myData = { ...data }
    myData.idsImg = uploadedMediaUrls;
    setData(myData);
    console.log(myData.idsImg);
  }, [uploadedMediaUrls])

  return (
    <div>
      <li className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center hover:border-blue-700 transition-colors">


        <input
          disabled={loadingUploadImage}
          multiple
          type="file"
          id="receipt-upload"
          className="hidden"
          accept="image/*"
          onChange={handleImageUpload}
        />
        <label
          htmlFor="receipt-upload"
          className="cursor-pointer flex flex-col items-center"
        >

          <div className="w-12 h-12 bg-blue-100 rounded-2xl flex items-center justify-center mb-3">
            {loadingUploadImage === false ? <Upload className="w-6 h-6 text-blue-600" /> : <Spinner width={24} height={24} className={"text-blue-600"} />}
          </div>
          <span className="text-gray-600 font-medium">
            {t("uploadImageHere")}
          </span>

        </label>

        {uploadedMediaUrls.length > 0 && (
          <div className="mt-2">
            <div className='flex justify-start'>
              {data?.idsImg?.map((url, index) => (
                <div className='image-preview' key={index}>
                  <img className='w-[100px] p-2' src={url} alt="uploaded" />
                  {!oldestImages.includes(url) && (
                    <button
                      className='icon-delete-image'
                      onClick={() => handleImageRemoveStorage(url)}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* {loadingUploadImage ? <Spinner /> : <></>} */}
      </li>

      <div className='row g-4'>
        {data?.media?.map((url, index) => (
          <div className='col-md-3 image-preview' key={index}>
            <img className='w-100' src={url} alt="uploaded" />
            {!oldestImages.includes(url) && (
              <button
                className='icon-delete-image'
                onClick={() => handleImageRemoveStorage(url)}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            )}
          </div>
        ))}
        <div className='row g-4'>
          {data?.paymentImage?.map((url, index) => (
            <div className='col-md-3 ' key={index}>
              <img className='w-16 h-16' src={url} alt="uploaded" />
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default UploadRequestImages;